import {
  FormControl,
  FormErrorMessage,
  HStack,
  Select,
} from '@wegroup/design-system';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { prefilledInputComponentStyling } from '../../../../constants/InputComponentStyling';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { UnitObject } from '../../../../types/CompanyScanTypes';
import TextInput from '../../advisory-flow-inputs/input/TextInput';

interface Props {
  question: FlowsQuestion;
}

const UnitInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
    error,
    prefilled,
  } = useFlowInputComponent({ question });
  const options = useQuestionEnum(question);

  const unitObject = value as UnitObject;

  const { control, getValues } = useForm<UnitObject>({
    defaultValues: unitObject || {
      value: undefined,
      unit: options[0].value,
    },
  });

  const handleFieldBlur = () => {
    if (getValues().unit && getValues().value)
      onBlur({ name: question.id, value: getValues() });
  };

  return (
    <FormControl isInvalid={!!error}>
      <HStack spacing="4">
        <Controller
          control={control}
          name="value"
          render={({ field: { onChange, value } }) => (
            <TextInput
              value={value}
              onChange={onChange}
              error={error?.message}
              onBlur={handleFieldBlur}
              type="number"
              data-test-id="ProdFac_TextInputComponent"
              prefilled={prefilled}
              symbol={question.rules.symbol}
              isDisabled={question.rules.is_disabled}
            />
          )}
        />

        <Controller
          control={control}
          name="unit"
          render={({ field: { onChange, value } }) => (
            <Select
              w="50%"
              h="44px"
              bg="white"
              borderRadius="sm"
              boxShadow="base"
              borderColor="#e4e4e4"
              _hover={{ borderColor: '#e4e4e4' }}
              onChange={onChange}
              onBlur={handleFieldBlur}
              _invalid={{
                border: '1px',
                borderColor: '#e4e4e4',
              }}
              value={value}
              isDisabled={question.rules.is_disabled}
              {...(prefilled && { sx: prefilledInputComponentStyling })}
            >
              {options.map(({ label, value }, index) => (
                <option key={index} value={value}>
                  {label}
                </option>
              ))}
            </Select>
          )}
        />
      </HStack>
      {error?.message && (
        <FormErrorMessage justifyContent="flex-end">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default UnitInputComponent;
